import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationBloc } from '@kp/auth/authentication.bloc';
import { UserBloc } from '@kp/user/user.bloc';
import { Status } from '@ktypes/models';
import { Subject, merge, of } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kp-screen-verification-no-code',
  templateUrl: './screen-verification-no-code.component.html',
  styleUrls: ['./screen-verification-no-code.component.scss'],
})
export class ScreenVerificationNoCodeComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();
  private _email: string;
  private _resetSignUpStatusSub$ = new Subject<void>();

  constructor(private _authenticationBloc: AuthenticationBloc, private _router: Router, private _userBloc: UserBloc) {}

  ngOnInit() {
    this._userBloc.existingUserEmail$.pipe(takeUntil(this._destroy$)).subscribe((userEmail) => {
      this._email = userEmail;
    });
    this._userBloc.getUserEmail(null, 'unconfirmedEmail');
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
    this._resetSignUpStatusSub$.complete();
  }

  resendCode() {
    this._resetSignUpStatusSub$.next(); // clear previous subscription
    this._userBloc.signUpStatus$
      .pipe(
        catchError((error) => {
          console.warn('error in signup component: ', error);
          return of(error);
        }),
        takeUntil(merge(this._destroy$, this._resetSignUpStatusSub$))
      )
      .subscribe((signUpStatus) => {
        // kutilBackButton directive navigates back to previous page;
        // this subscription is to capture errors for debugging purposes
        if (signUpStatus?.status === Status.error) {
          // possible errors:
          // - bad request,
          // - KumanuIdentityServiceError - CodeDeliveryFailureException,
          // - KumanuIdentityServiceError - UsernameExistsException
          console.warn('error in signup component status: ', signUpStatus?.message);
        }
      });

    if (this._email !== '') {
      // clear any existing Payment Required Error Messages, then attempt sign-up request
      this._authenticationBloc.resetPaymentRequiredErrorMessage();
      this._userBloc.signUp(this._email);
    }
  }
}
